import { BlockStack, Text } from '@shopify/polaris'
import NotFoundIllustration from '@/illustrations/not-found.svg?react'
import i18next from 'i18next'

const NotFound = () => {
  return (
    <div className="error-page">
      <div className="error-page__illustration">
        <div className="illustration" style={{ width: '240px' }}>
          <NotFoundIllustration />
        </div>
      </div>
      <div className="error-page__content">
        <BlockStack gap="600">
          <Text as="h3" variant="headingXl">
            {i18next.t('notFoundTitle')}
          </Text>
          <Text as="p" variant="bodyLg" tone="subdued">
            {i18next.t('notFoundDescription')}
          </Text>
        </BlockStack>
      </div>
    </div>
  )
}

export { NotFound }
